var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 47,
    viewBox: "0 0 95 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.1182L88.9229 35.1034V0L1 33.0002V43.1182Z",
    fill: "#EFEFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3927 46.913H88.9224V0L92.3927 3.48218V46.913Z",
    fill: "#727674"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9224 0L94.3949 5.06895V9.90386L88.9224 4.92059V0Z",
    fill: "#A0A09C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9224 7.67529L94.3949 12.5641V16.589L88.9224 12.699",
    fill: "#A0A09C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9224 17.7227L94.3949 21.5039V36.4601L88.9224 35.1034V17.7227Z",
    fill: "#A0A09C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3953 9.90426L92.3931 10.6135V8.08105L94.3953 9.90426Z",
    fill: "#9CA5A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3953 16.5889L92.3931 17.2839V15.1655L94.3953 16.5889Z",
    fill: "#9CA5A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3953 36.46L92.3931 36.6092V35.9634L94.3953 36.46Z",
    fill: "#9CA5A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9232 35.1035V46.9131H2.00977V43.0263L88.9232 35.1035Z",
    fill: "#A0A09C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9229 12.6987L1 37.4929V38.6274L88.9229 17.7225V12.6987Z",
    fill: "#9CA5A9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9229 4.9209L1 35.2251V36.0352L88.9229 7.67554V4.9209Z",
    fill: "#9CA5A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.26 19.2954L1 39.2285",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 22.4556L1 39.7554",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 25.0488L1 40.2414",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 27.8848L1 41.0923",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 30.397L1 41.7202",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8546 33.0708L1 42.2265",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.26 3.22559L1 34.0154",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 36.6092L87.8546 9.90381",
    stroke: "black",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.bfe229419e1c0b1d3ea5.svg";
export { ForwardRef as ReactComponent };